// A tax checkbox on the Tasks grid (T4 / T5 / T1135 / Compilation).
//
// These replaced the old StatusOption dropdowns, which read Client-level fields
// off Task rows and so had always rendered blank.
export default function CheckboxCell({ checked, onChange, disabled = false }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <input
        type="checkbox"
        checked={!!checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
        style={{
          width: 16,
          height: 16,
          cursor: disabled ? "default" : "pointer",
          accentColor: "#0073ea",
        }}
      />
    </div>
  );
}
